/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S12_P1Inputs */

const tr_kullanim_s12_p1 = /** @type {(inputs: Kullanim_S12_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik, Kullanıcı'nın seçtiği süre için (aylık plan 30 gün, yıllık plan 365 gün) peşin ödeme karşılığında kurulur ve sürenin sonunda kendiliğinden sona erer. Sözleşme otomatik olarak yenilenmez; Kullanıcı'nın kartından yenileme amacıyla tahsilat yapılmaz.`)
};

const en_kullanim_s12_p1 = /** @type {(inputs: Kullanim_S12_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The subscription is established for the term chosen by the User (monthly plan 30 days, yearly plan 365 days) against advance payment and ends by itself at the end of the term. The Agreement does not renew automatically; no charge is made to the User's card for renewal.`)
};

const de_kullanim_s12_p1 = /** @type {(inputs: Kullanim_S12_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Abonnement wird für die vom Nutzer gewählte Laufzeit (Monatstarif 30 Tage, Jahrestarif 365 Tage) gegen Vorauszahlung geschlossen und endet mit Ablauf der Laufzeit von selbst. Der Vertrag verlängert sich nicht automatisch; zur Verlängerung wird keine Karte des Nutzers belastet.`)
};

const ru_kullanim_s12_p1 = /** @type {(inputs: Kullanim_S12_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписка оформляется на выбранный Пользователем срок (месячный тариф 30 дней, годовой тариф 365 дней) с предоплатой и по окончании срока прекращается сама. Договор не продлевается автоматически; списания с карты Пользователя для продления не производятся.`)
};

/**
* | output |
* | --- |
* | "The subscription is established for the term chosen by the User (monthly plan 30 days, yearly plan 365 days) against advance payment and ends by itself at th..." |
*
* @param {Kullanim_S12_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s12_p1 = /** @type {((inputs?: Kullanim_S12_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S12_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s12_p1(inputs)
	if (locale === "de") return de_kullanim_s12_p1(inputs)
	if (locale === "ru") return ru_kullanim_s12_p1(inputs)
	return tr_kullanim_s12_p1(inputs)
});